import { BreakpointValueProp } from "@toolkit/Framework/Common/Utilities/breakpointValues";
import getCurrentBreakpointValue from "@toolkit/Framework/Common/Utilities/getCurrentBreakpointValue";
import { useWindowContext } from "@toolkit/Framework/Components/WindowContext";
import { useTheme } from "styled-components";

const useCurrentBreakpointValue = <T extends BreakpointValueProp<any>>(values: T) => {
    const theme = useTheme();
    const { currentBreakpoint } = useWindowContext();

    return getCurrentBreakpointValue(values, currentBreakpoint, theme);
};

export default useCurrentBreakpointValue;
